import { render } from "./GallerySelectModule.vue?vue&type=template&id=36967514&scoped=true"
import script from "./GallerySelectModule.vue?vue&type=script&lang=js"
export * from "./GallerySelectModule.vue?vue&type=script&lang=js"

import "./GallerySelectModule.vue?vue&type=style&index=0&id=36967514&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36967514"]])

export default __exports__